(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';

        var TrackingScriptName = 'googleAnalytics4';
        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googleAnalytics4", TrackingModel);
        if (!Tracker) return;

        window.dataLayer = window.dataLayer || [];
        var listToProductMap = { sessionID: '', items: [] };
        var homeQuickBuyItemIndex = 0;
        var triggerViewItemList = null;

        Init();

        function Init() {

            var trackedLists = []; // Save tracked lists
            var viewedItems = []; // Save viewed items in lists

            listToProductMap = JSON.parse(localStorage.getItem('listToProductMap')) || listToProductMap;

            //TRACK user id
            var loginEventFromStorage = localStorage.getItem('login_event'); // Get event stored from login success message
            var currentUserModelFromStorage = localStorage.getItem('CurrentUserModel'); // Current user model to get user id

            if (currentUserModelFromStorage !== null) {
                var currentUserModel = JSON.parse(currentUserModelFromStorage);
                var userIdentifier = currentUserModel.UserIdentifier;

                if (loginEventFromStorage !== null) { //TRACK login and user id - Push "login" event
                    localStorage.removeItem("login_event");
                    var loginEvent = JSON.parse(loginEventFromStorage);

                    dataLayer.push({ 'method': null });
                    dataLayer.push({
                        'event': 'login',
                        'method': loginEvent.method, // Login method
                        'userId': userIdentifier
                    });
                } else if (userIdentifier !== null) {
                    dataLayer.push({ //TRACK user id, for use on all events bellow
                        'userId': userIdentifier
                    });
                }

                dataLayer.push({
                    'event': 'vendd_user_set' // This event fires general configuration tag in GTM
                });
            }

            //TRACK product list - Push "view_item_list" Event            
            if (TrackingModel.IsHomePage || TrackingModel.IsProductListPage || TrackingModel.IsProductDetailsPage || TrackingModel.IsBrandPage || TrackingModel.IsCartPage || TrackingModel.IsAllOtherPages) {

                function checkViewableLists() { // Function to check if a list is in viewport

                    TrackingModel = LhApp.Function.Tracking.getTrackingModel(); // Updated Tracking Model to include lazy product lists
                    if (!TrackingModel.ProductListsData || TrackingModel.ProductListsData.length < 1) return; // If ProductListsData is not empty

                    Object.entries(TrackingModel.ProductListsData).forEach(function (list) { // Iterate through product lists

                        var listName = list[0]; // List Name                        
                        // Current product list element
                        var $thisEl = (listName.indexOf("'") > -1) ? $('[data-list-title="' + listName + '"]') : $("[data-list-title='" + listName + "']");
                        var version = parseInt($thisEl.attr('data-list-version')) || 1; // Check product list version
                        var trackedItems = list[1].length; // Items count

                        var listAlreadyTracked = checkTrackedLists(listName, version, trackedItems); // Check if this list has already tracked
                        if (listAlreadyTracked) return;

                        if ($thisEl.is(':visible') && isElementPartialyInViewport($thisEl, { height: 100, width: 100 })) { // Check if this list is in view port
                            trackedLists.push({ listName, version, trackedItems }); // Save on trackedLists

                            if ($thisEl.data('trackinglist-type'))
                                list.type = $thisEl.data('trackinglist-type');

                            trackList(list);
                            bindSelectItemEvent($thisEl, list); // Helper to select item event
                        }

                        function checkTrackedLists(listName, version, trackedItems) {
                            var listMatched = trackedLists.filter(function (list) {
                                return list.listName === listName && list.version === version && list.trackedItems == trackedItems
                            })[0];

                            return (listMatched !== undefined);
                        }
                    });

                }

                function trackList(list) { // Function to send list data to the dataLayer
                    var items = []; // Push Each Item (product) from the model to the array
                    var listKey = ''; // List Name
                    var listValues = list[1]; // List Content

                    if (list.type == 'amazon-recom-pd')
                        listKey = 'Amazon Recommendation PD';
                    else if (list.type == 'amazon-recom-cart')
                        listKey = 'Amazon Recommendation Cart';
                    else
                        listKey = list[0];

                    var $thisEl = (list[0].indexOf("'") > -1) ? $('[data-list-title="' + list[0] + '"]') : $("[data-list-title='" + list[0] + "']");
                    var trackedItems = parseInt($thisEl.attr('data-list-tracked-items')) || 0;
                    var numOfItems = listValues.length;

                    if (trackedItems > 0 && trackedItems < numOfItems) {
                        listValues.splice(0, trackedItems); // Remove already tracked items
                    }

                    listValues.forEach(function (product, index) {
                        var pdIndex = index + 1;
  
                        var itemDataFormatted = {
                            item_id: product.ProductId.toString(),
                            item_name: product.Name,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: pdIndex,
                            item_brand: product.Brand,
                            item_list_id: listKey,
                            item_list_name: listKey,
                            item_variant: product.Color,
                            price: product.PriceWithoutVatN,
                            quantity: product.Quantity
                        };

                        // Extend item data with category levels
                        var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                        items.push(itemDataFormattedExtended);
                        viewedItems.push(itemDataFormattedExtended);
                    });

                    var batches = breakArrayTo(10, items);

                    batches.forEach(function (batch) {
                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'view_item_list', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'item_list_id': listKey,
                                'item_list_name': listKey,
                                'currency': LhApp.Context.Currency.Code,
                                'items': batch // ProductListsData (Model) to DataLayer
                            }
                        })
                    });

                    $thisEl.attr('data-list-tracked-items', numOfItems); // Update element with tracked items number

                    function breakArrayTo(batchSize, array) {
                        var batches = [];
                        var index = 0;

                        while (index < array.length) {
                            var batch = array.slice(index, index + batchSize)
                            batches.push(batch);
                            index += batchSize;
                        }

                        return batches;
                    }
                }

                triggerViewItemList = checkViewableLists;

                //Get first product list and check for lazyloadprices
                var firstlistName = Object.keys(TrackingModel.ProductListsData)[0];
                if (firstlistName) {
                    var $firstPL = (firstlistName.indexOf("'") > -1) ? $('[data-list-title="' + firstlistName + '"]') : $("[data-list-title='" + firstlistName + "']");                
                    var lazyLoadPrices = $('.list-lazy-load-prices', $firstPL).first().text().toLowerCase().trim() === "true";
                    var customPrices = currentUserModel && currentUserModel.HasCustomPrices;

                    if (!customPrices && !lazyLoadPrices) {                    
                        checkViewableLists(); // Runs on page load
                        $(window).scroll($.debounce(300, checkViewableLists)); // Runs when user scrolls
                    }
                }
            }

            //TRACK select item from list - Push "select_item" Event
            function bindSelectItemEvent($list, list) {
                var listKey = ''; // List Name

                if (list.type == 'amazon-recom-pd')
                    listKey = 'Amazon Recommendation PD';
                else if (list.type == 'amazon-recom-cart')
                    listKey = 'Amazon Recommendation Cart';
                else
                    listKey = list[0];

                $('.image-container a, .heading a, .availability-container a', $list).on('click', function (evt) {

                    var productId = $(this).closest('[data-productid]').attr('data-productid');
                    var productObject = viewedItems.filter(function (i) { return i.item_id == productId && i.item_list_id == listKey })[0];

                    var cookieData = { listKey: listKey, index: productObject.index };
                    cookieData = encodeURIComponent(JSON.stringify(cookieData));
                    Cookies.set("LastListObj", cookieData, { samesite: 'Lax' });

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'select_item', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'item_list_id': listKey,
                            'item_list_name': listKey,
                            'items': [productObject] // ProductData (Model) to DataLayer
                        }
                    })
                })
            }

            //TRACK Home Quick Buy
            if (TrackingModel.IsHomePage) {
                var $quickBuySearchBox = $('.x-cart-searchbox');

                $quickBuySearchBox.on('listLoaded', function (evt, maxResults) {
                    var $productsList = $('.products-list', $quickBuySearchBox);
                    var $products = $('.js-list-item', $productsList);
                    var startIndex = $products.length - parseInt(maxResults);
                    var items = []; // Push Each Item (product) from the model to the array
                    var listKey = 'Γρήγορη Αγορά';

                    $products.each(function (index, product) {
                        if (index < startIndex) return;
                        var $product = $(product);
                        var id = $product.data('productid');
                        var name = $product.data('name');
                        var pdIndex = index + 1;

                        var itemDataFormatted = {
                            item_id: id.toString(),
                            item_name: name,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: pdIndex,
                            item_list_id: listKey,
                            item_list_name: listKey,
                            quantity: 1
                        }

                        items.push(itemDataFormatted);

                        // On click
                        $product.on('click', function () {
                            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                'event': 'select_item', // Event Name to identify in Tag Manager
                                'ecommerce': {
                                    'item_list_id': listKey,
                                    'item_list_name': listKey,
                                    'items': [itemDataFormatted] // ProductData (Model) to DataLayer
                                }
                            })
                            homeQuickBuyItemIndex = itemDataFormatted.index;
                        });
                    });

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'view_item_list', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'item_list_id': listKey,
                            'item_list_name': listKey,
                            'currency': LhApp.Context.Currency.Code,
                            'items': items // ProductListsData (Model) to DataLayer
                        }
                    })
                })
            }

            //TRACK product details - Push "view_item" Event
            if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData) {

                var lazyLoadPrices = $('.details-lazy-load-prices').text().toLowerCase().trim() === "true";
                var customPrices = currentUserModel && currentUserModel.HasCustomPrices;
                var skuQueryString = getQueryStringValueByName('skuid').length > 0;

                if (!lazyLoadPrices && !skuQueryString && !customPrices) {
                    var list = []; // List to send to dataLayer

                    if (TrackingModel.ProductData.length > 0) { // Check if it is simple product or Get the look list
                        list = TrackingModel.ProductData;
                    } else if (TrackingModel.ProductListsData.getthelooklist && TrackingModel.ProductListsData.getthelooklist.length > 0) {
                        list = TrackingModel.ProductListsData.getthelooklist;
                    }
    
                    var items = []; // Push each item from the model to the array
                    var totalPrice = 0; // Value to add total price of all items
    
                    list.forEach(function (product, index) {
    
                        var lastListCookie = Cookies.get('LastListObj');
                        lastListCookie = (lastListCookie) ? JSON.parse(lastListCookie) : null;
                        var pdList = (lastListCookie && lastListCookie.listKey) ? lastListCookie.listKey : '';
                        var pdIndex = (lastListCookie && lastListCookie.index) ? lastListCookie.index : 0;
                       
                        var itemDataFormatted = {
                            item_id: product.ProductId.toString(),
                            item_name: product.Name,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: pdIndex,
                            item_brand: product.Brand,
                            item_list_id: pdList,
                            item_list_name: pdList,
                            price: product.PriceWithoutVatN,
                            quantity: product.Quantity
                        };
    
                        // Extend item data with category levels
                        var itemDataFormattedExtended = addCategories(itemDataFormatted, product);
    
                        totalPrice += parseFloat(product.PriceWithoutVatN);
    
                        items.push(itemDataFormattedExtended);
                    });
    
                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'view_item', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'currency': LhApp.Context.Currency.Code,
                            'value': totalPrice,
                            'items': items // ProductData (Model) to DataLayer
                        }
                    });
                }
            }

            //TRACK checkout Angular(ready) - Push "begin_checkout" Event
            if (TrackingModel.IsCheckoutPage) {
                var ready = false;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        //register events once
                        if (!ready) {
                            ready = true;

                            var smScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                            if (!smScope) return;

                            var items = []; // Push Each Item from the model to the array
                            var coupons = smScope.Model.Data.Coupons;
                            var couponCode = (coupons && coupons.length > 0) ? (coupons.length > 1) ? combineCoupons(coupons) : coupons[0].Code : null;

                            smScope.Model.Data.Products.forEach(function (product, index) {

                                var pdFirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                                var pdPriceWithoutVatN = product.PriceWithoutVatText;
                                var pdList = '', pdIndex = 0;

                                if (product.IsFreeGift) {
                                    pdList = 'FREE GIFT';
                                    pdIndex = 1;
                                } else {
                                    var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                                    pdList = (mapItem) ? mapItem.list : '';
                                    pdIndex = (mapItem) ? mapItem.index : 0;
                                }

                                var itemDataFormatted = {
                                    item_id: product.ProductId.toString(),
                                    item_name: product.Title,
                                    affiliation: "Online Store",
                                    currency: LhApp.Context.Currency.Code,
                                    index: pdIndex,
                                    item_brand: product.ManufacturerName,
                                    item_list_id: pdList,
                                    item_list_name: pdList,
                                    item_variant: pdFirstDimension,
                                    price: pdPriceWithoutVatN,
                                    quantity: product.Quantity
                                };

                                // Extend item data with category levels
                                var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                                items.push(itemDataFormattedExtended);
                            });

                            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                'event': 'begin_checkout', // Event Name to identify in Tag Manager
                                'ecommerce': {
                                    'currency': LhApp.Context.Currency.Code,
                                    'value': smScope.Model.Data.ProductsCostWithoutVat,
                                    'coupon': couponCode,
                                    'items': items // CartProductsData (Model) to DataLayer
                                }
                            })

                        }
                    });
                }
            }

            //TRACK checkout Angular(ready) - Push "add_shipping_info" && "add_payment_info" Event
            if (TrackingModel.IsCheckoutPage) {

                if (typeof angular === 'undefined') return;

                angular.element(document).ready(function () {
                    var shippingInfoPushed = null;
                    var paymentInfoPushed = null;

                    var orderScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                    var watchGroup = [
                        'Model.Data.ShippingMethod.CompanyId',
                        'Model.Data.ShippingMethod.MethodId',
                        'Model.Data.Shipping.GeoZones',
                        'Model.Data.Store.Id',
                        'Model.Data.PaymentMethod.MethodId',
                        'Model.Data.PaymentMethod.ProcessorId'
                    ];

                    orderScope.$watchGroup(watchGroup, function (newValues, oldValues, scope) {

                        var newCompanyId = newValues[0], newMethodId = newValues[1], newGeoZones = newValues[2], newStoreId = newValues[3];
                        var oldCompanyId = oldValues[0], oldMethodId = oldValues[1], oldGeoZones = oldValues[2];
                        var newPMethodId = newValues[4], newProcessorId = newValues[5];
                        var oldPMethodId = oldValues[4], oldProcessorId = oldValues[5];
                        var deliveryPointCode = scope.Model.Data.DeliveryPoint.Code;

                        checkShipping();
                        function checkShipping() {
                            var deliveryPointName = scope.Model.Data.DeliveryPoint.Name;

                            if (!deliveryPointCode || !deliveryPointName || shippingInfoPushed === deliveryPointName) return;

                            if (deliveryPointCode === 'onSite') {
                                if (newGeoZones.length < 1 || !newCompanyId || !newMethodId) return;
                                if (newGeoZones === oldGeoZones && newCompanyId === oldCompanyId && newMethodId === oldMethodId) return;

                                pushAddShippingInfo(deliveryPointName);
                                shippingInfoPushed = deliveryPointName;

                            } else if (deliveryPointCode === 'fromStore') {
                                if (!newStoreId) return;

                                pushAddShippingInfo(deliveryPointName);
                                shippingInfoPushed = deliveryPointName;
                            }
                        }

                        checkPayment();
                        function checkPayment() {
                            var paymentMethodName = scope.Model.Data.PaymentMethod.Name;
                            var processorCode = scope.Model.Data.PaymentMethod.ProcessorCode;
                            var paymentInfo = paymentMethodName + ' ' + processorCode;

                            if (paymentInfoPushed === paymentInfo) return;
                            if (!newPMethodId || !newProcessorId) return;

                            if (deliveryPointCode === 'onSite') {
                                if (newGeoZones.length < 1) return;
                                if (newGeoZones === oldGeoZones
                                    && newPMethodId === oldPMethodId
                                    && newProcessorId === oldProcessorId
                                    && newCompanyId === oldCompanyId
                                    && newMethodId === oldMethodId) return;

                                pushAddPaymentInfo(paymentInfo);
                                paymentInfoPushed = paymentInfo;

                            } else if (deliveryPointCode === 'fromStore') {
                                if (!newStoreId) return;
                                if (paymentInfoPushed && newPMethodId === oldPMethodId && newProcessorId === oldProcessorId) return;

                                pushAddPaymentInfo(paymentInfo);
                                paymentInfoPushed = paymentInfo;
                            }
                        }
                    });

                    function pushAddShippingInfo(deliveryPointName) {

                        var items = []; // Push Each Item from the model to the array
                        var coupons = orderScope.Model.Data.Coupons;
                        var couponCode = (coupons && coupons.length > 0) ? (coupons.length > 1) ? combineCoupons(coupons) : coupons[0].Code : null;

                        orderScope.Model.Data.Products.forEach(function (product, index) {

                            var pdFirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                            var pdPriceWithoutVatN = product.PriceWithoutVat;
                            var pdList = '', pdIndex = 0;

                            if (product.IsFreeGift) {
                                pdList = 'FREE GIFT';
                                pdIndex = 1;
                            } else {
                                var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                                pdList = (mapItem) ? mapItem.list : '';
                                pdIndex = (mapItem) ? mapItem.index : 0;
                            }

                            var itemDataFormatted = {
                                item_id: product.ProductId.toString(),
                                item_name: product.Title,
                                affiliation: "Online Store",
                                currency: LhApp.Context.Currency.Code,
                                index: pdIndex,
                                item_brand: product.ManufacturerName,
                                item_list_id: pdList,
                                item_list_name: pdList,
                                item_variant: pdFirstDimension,
                                price: pdPriceWithoutVatN,
                                quantity: product.Quantity
                            };

                            // Extend item data with category levels
                            var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                            items.push(itemDataFormattedExtended);
                        });

                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_shipping_info', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': orderScope.Model.Data.ProductsCostWithoutVat,
                                'coupon': couponCode,
                                'shipping_tier': deliveryPointName,
                                'items': items
                            }
                        })
                    }

                    function pushAddPaymentInfo(paymentInfo) {

                        var items = []; // Push Each Item from the model to the array
                        var coupons = orderScope.Model.Data.Coupons;
                        var couponCode = (coupons && coupons.length > 0) ? (coupons.length > 1) ? combineCoupons(coupons) : coupons[0].Code : null;

                        orderScope.Model.Data.Products.forEach(function (product, index) {

                            var pdFirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                            var pdPriceWithoutVatN = product.PriceWithoutVat;
                            var pdList = '', pdIndex = 0;

                            if (product.IsFreeGift) {
                                pdList = 'FREE GIFT';
                                pdIndex = 1;
                            } else {
                                var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                                pdList = (mapItem) ? mapItem.list : '';
                                pdIndex = (mapItem) ? mapItem.index : 0;
                            }

                            var itemDataFormatted = {
                                item_id: product.ProductId.toString(),
                                item_name: product.Title,
                                affiliation: "Online Store",
                                currency: LhApp.Context.Currency.Code,
                                index: pdIndex,
                                item_brand: product.ManufacturerName,
                                item_list_id: pdList,
                                item_list_name: pdList,
                                item_variant: pdFirstDimension,
                                price: pdPriceWithoutVatN,
                                quantity: product.Quantity
                            };

                            // Extend item data with category levels
                            var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                            items.push(itemDataFormattedExtended);
                        });

                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_payment_info', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': orderScope.Model.Data.ProductsCostWithoutVat,
                                'coupon': couponCode,
                                'payment_type': paymentInfo,
                                'items': items
                            }
                        })
                    }
                });
            }

            //TRACK order completion - Push "purchase" Event
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {

                //get transaction cookie
                var transactionCookie = Cookies.get('transaction_id');

                //check if transaction cookie already exists
                if (typeof transactionCookie === 'undefined' || (typeof transactionCookie !== 'undefined' && parseInt(transactionCookie) !== TrackingModel.Order.Id)) {
                    var ready = false;

                    if (typeof angular !== 'undefined') {
                        angular.element(document).ready(function () {
                            //register events once
                            if (!ready) {
                                ready = true;

                                var smScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                                if (!smScope) return;

                                var items = []; // Push Each Item from the model to the array
                                var coupons = smScope.Model.Data.Coupons;
                                var couponCode = (coupons && coupons.length > 0) ? (coupons.length > 1) ? combineCoupons(coupons) : coupons[0].Code : null;

                                smScope.Model.Data.Products.forEach(function (product, index) {

                                    var pdFirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                                    var pdPriceWithoutVatN = product.PriceWithoutVat;
                                    var pdList = '', pdIndex = 0;

                                    if (product.IsFreeGift) {
                                        pdList = 'FREE GIFT';
                                        pdIndex = 1;
                                    } else {
                                        var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                                        pdList = (mapItem) ? mapItem.list : '';
                                        pdIndex = (mapItem) ? mapItem.index : 0;
                                    }

                                    var itemDataFormatted = {
                                        item_id: product.ProductId.toString(),
                                        item_name: product.Title,
                                        affiliation: "Online Store",
                                        currency: LhApp.Context.Currency.Code,
                                        index: pdIndex,
                                        item_brand: product.ManufacturerName,
                                        item_list_id: pdList,
                                        item_list_name: pdList,
                                        item_variant: pdFirstDimension,
                                        price: pdPriceWithoutVatN,
                                        quantity: product.Quantity
                                    };

                                    // Extend item data with category levels
                                    var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                                    items.push(itemDataFormattedExtended);
                                });

                                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                                dataLayer.push({
                                    'event': 'purchase', // Event Name to identify in Tag Manager
                                    'ecommerce': {
                                        'transaction_id': TrackingModel.Order.Id,
                                        'affiliation': TrackingModel.Order.StoreName || "Online Store",
                                        'value': TrackingModel.Order.ProductsCostWithouVatN,
                                        'tax': TrackingModel.Order.VatCostN,
                                        'shipping': TrackingModel.Order.ShippingCostWithoutVatN,
                                        'currency': LhApp.Context.Currency.Code,
                                        'coupon': couponCode,
                                        'items': items // CartProductsData (Model) to DataLayer
                                    }
                                })
                            }
                        });
                    }

                    //set current transaction cookie
                    Cookies.set("transaction_id", TrackingModel.Order.Id, { samesite: 'Lax' });
                }
            }

            //TRACK share - Push "share" Event from addthis
            if (typeof addthis !== 'undefined') {
                function addThisEventHandler(evt) {
                    if (evt.type == "addthis.menu.share") {

                        var item_id = (LhApp.Context.Item.Id) || '';

                        dataLayer.push({ 'method': null, 'content_type': null, 'item_id': null, 'url': null }); // Clear the previous object.
                        dataLayer.push({
                            'event': 'share', // Event Name to identify in Tag Manager
                            'method': evt.data.service, // Share Network
                            'content_type': inlineAdminGlobalVariables.EntityCode, // Content to share
                            'item_id': item_id.toString(), // Content Item id
                            'url': window.location.href // Content Url
                        });

                    }
                }
                addthis.addEventListener('addthis.menu.share', addThisEventHandler);
            }

            //TRACK share - Push "share" Event from html anchor clicks
            if ($('.x-share-buttons .initialized').length > 0) {
                $('.x-share-buttons .initialized').on("click", "li a", function () {

                    var item_id = (LhApp.Context.Item.Id) || '';

                    dataLayer.push({ 'method': null, 'content_type': null, 'item_id': null, 'url': null }); // Clear the previous object.
                    dataLayer.push({
                        'event': 'share', // Event Name to identify in Tag Manager
                        'method': $(this).text(), // Share Network
                        'content_type': inlineAdminGlobalVariables.EntityCode, // Content to share
                        'item_id': item_id.toString(), // Content Item id
                        'url': window.location.href // Content Url
                    });

                });
            }

            //TRACK share - Push "share" Event from addToAny
            if (typeof a2a !== 'undefined') {
                // AddToAny "onShare" callback functions setup
                a2a_config.callbacks = a2a_config.callbacks || [];
                a2a_config.callbacks.push({
                    share: my_addtoany_onshare,
                });

                function my_addtoany_onshare(data) {
                    var item_id = (LhApp.Context.Item.Id) || '';

                    dataLayer.push({ 'method': null, 'content_type': null, 'item_id': null, 'url': null }); // Clear the previous object.
                    dataLayer.push({
                        'event': 'share', // Event Name to identify in Tag Manager
                        'method': data.service, // Share Network
                        'content_type': inlineAdminGlobalVariables.EntityCode, // Content to share
                        'item_id': item_id, // Content Item id
                        'url': window.location.href // Content Url
                    });
                }
            }

            //TRACK promotion - Push "view_promotion" Event
            if ($('[data-view_promotion="true"]').length > 0) {

                function checkViewablePromos() {

                    $('[data-view_promotion="true"]').each(function () {
                        var $this = $(this);

                        if ($this.is(':visible') && isElementPartialyInViewport($this, { height: 100, width: 100 })) { // Check if this promotion is in view port

                            if (trackedPromo.indexOf($this.attr('data-creative_slot')) >= 0) return; // This promo is already tracked

                            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                'event': 'view_promotion', // Event Name to identify in Tag Manager
                                'ecommerce': {
                                    creative_slot: $this.attr('data-creative_slot'),
                                    creative_name: $this.attr('data-creative_name'),
                                    items: [{
                                        item_id: $this.attr('data-item-id')
                                    }]
                                }
                            })

                            trackedPromo.push($this.attr('data-creative_slot'));
                        }

                        if ($this.parents('.x-slider').length > 0) {
                            promoInSlider = true;
                        }
                    });

                }

                var trackedPromo = []; // Save tracked promotions
                var promoInSlider = false; // Check if promotion sits inside slider

                checkViewablePromos(); // Runs on page load

                $(window).scroll($.debounce(300, checkViewablePromos)); // Runs when user scrolls

                if (promoInSlider) {
                    setInterval(checkViewablePromos, 300); // Repeat if slider
                }
            }

            //TRACK select promotion - Push "select_promotion" Event
            $('[data-view_promotion="true"]').click('a', function (evt) {
                var $this = $(this);

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'select_promotion', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        creative_slot: $this.attr('data-creative_slot'),
                        creative_name: $this.attr('data-creative_name'),
                        items: [{
                            item_id: $this.attr('data-item-id')
                        }]
                    }
                })
            });

            //TRACK search - Push "search" Event
            trackSearch();
            function trackSearch() {

                hookMethod('bind', '.x-searchbox.elastic', function (wrapper) {
                    debounce(function () { pushSearch(wrapper); }, 2000);
                    bindResultClick(wrapper);
                    bindSuggestionClick(wrapper);
                });

                function pushSearch(wrapper) {
                    var searchTerm = $('#searchInputId', wrapper).val();
                    var suggestionsCount = $('.suggestion', wrapper).length;
                    var resultsCount = $('.result-item', wrapper).length;

                    dataLayer.push({
                        'event': 'search',
                        'searchTerm': searchTerm,
                        'searchResults': resultsCount,
                        'searchSuggestions': suggestionsCount
                    });
                };

                function bindResultClick(wrapper) {
                    var $searchResults = $('.x-elastic-results-list', wrapper);
                    $searchResults.on('click', 'a', function (evt) {
                        var title = $(evt.currentTarget).text();
                        var titleTrimmed = title.replace(/\s+/g, ' ').trim();

                        if (titleTrimmed == '') {
                            var $resultItem = $(evt.currentTarget).closest('.result-item');
                            titleTrimmed = $('.heading', $resultItem).text().replace(/\s+/g, ' ').trim();
                        }

                        dataLayer.push({
                            'event': 'searchResultClick',
                            'searchResultItem': titleTrimmed
                        });
                    });
                };

                function bindSuggestionClick(wrapper) {
                    var $searchSuggestions = $('.x-elastic-suggestions', wrapper);
                    $searchSuggestions.on('click', '.suggestion', function (evt) {
                        var title = $(evt.currentTarget).text();
                        var titleTrimmed = title.replace(/\s+/g, ' ').trim();

                        dataLayer.push({
                            'event': 'searchSuggestionClick',
                            'searchSuggestionItem': titleTrimmed
                        });
                    });
                };

                function hookMethod(methodName, element, hookedFunc) {
                    $(element).each(function (i, wrapper) {
                        if (!wrapper[methodName]) return;

                        var originalMethod = wrapper[methodName];

                        wrapper[methodName] = function (args) {
                            originalMethod.call(wrapper, args);
                            hookedFunc(wrapper, args);
                        }
                    });
                }

                function debounce(func, delay) {
                    debounce.timeout = debounce.timeout || 0;
                    clearTimeout(debounce.timeout);
                    debounce.timeout = setTimeout(function () {
                        func();
                    }, delay);
                }

            }

        } //END of function Init()

        // IMPORTANT execute these scripts in all other pages except checkout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            var pageTemplate = LhApp.Context.Item.Template;
            var _cartAddResponses = []; // Used for add to cart
            var _wishAddResponses = []; // Used for add to wishlist
            var cartModel; // Saves current cartModel state
            var previousCartModel; // Saves cartModel before change
            var wishModel; // Saves current wishModel state
            var currentColor; // Used to check view item event if user views different color
            var dontTrackNextViewCart = false; // Used to prevent firing view cart event after item removal
            var idsToRemove = []; // Used for multiple items removal
            var loginTracked = false; // Prevent double fire of login event
            var quantityChanged = false; // Used for add/remove from cart on view cart message
            var firstCartChanged = true;
            var PLScrollRegistered = false; // Used for triggering view_item_list on scroll only once

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                Init();
            });

            //Sync listToProductMap with products in cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, Vendd.Cart, function (envelope) {
                if (!firstCartChanged) return;
                firstCartChanged = false;

                if (!envelope || !envelope.message || !envelope.message.data || !envelope.message.data.Cart || !envelope.message.data.Cart.Items) return;

                var cartItems = envelope.message.data.Cart.Items;
                if (cartItems.length < 1) {
                    listToProductMap.items = [];
                    return;
                };

                if (listToProductMap.items.length < 1) return;

                //Update listToProductMap.items to include only cart items
                listToProductMap.items = listToProductMap.items.filter(function (mapItem) {
                    return itemInCart(mapItem, cartItems);
                });

                //Check if mapItem is in cartItems
                function itemInCart(mapItem, cartItems) {
                    var inCart = cartItems.some(function (cartItem) {
                        return cartItem.VariantId === mapItem.variantId;
                    });

                    return inCart;
                }

                //Save updated listToProductMap
                localStorage.setItem('listToProductMap', JSON.stringify(listToProductMap));
            });

            //HELPER Record Quantity Change
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantitySuccess, TrackingScriptName, function (envelope) {
                if (!envelope.message || !envelope.message.data || !envelope.message.data.success) return;
                if (envelope.message.data.code === 'OperationSuccesful' || envelope.message.data.code === 'OperationSuccesfulLastPieceAddedToCart') {
                    quantityChanged = true;
                }
            });

            //Track Quantity Change from cart changed message
            function trackQuantityChange(newCartModel, previousCartModel) {
                quantityChanged = false;

                var changedItem = findChangedItem();
                if (!changedItem) return;

                var eventType = (changedItem.currentItemState.Quantity > changedItem.previousItemState.Quantity) ? 'add_to_cart' : 'remove_from_cart';
                pushEvent(eventType);

                function findChangedItem() { // Find the item that changed
                    var changedItem = null;

                    newCartModel.Items.forEach(function (currentItem) {
                        var previousItem = previousCartModel.Items.filter(function (item) {
                            return item.VariantId === currentItem.VariantId && item.Quantity !== currentItem.Quantity
                        })[0];

                        if (!previousItem) return;

                        changedItem = {
                            currentItemState: currentItem,
                            previousItemState: previousItem
                        };

                    });

                    return changedItem;
                }

                function pushEvent(eventType) {
                    var currentQuantity = changedItem.currentItemState.Quantity;
                    var previousQuantity = changedItem.previousItemState.Quantity;
                    var product = changedItem.currentItemState;
                    var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                    var listKey = (mapItem) ? mapItem.list : '';
                    var index = (mapItem) ? mapItem.index : 0;
                    var quantity = (eventType === 'add_to_cart') ? currentQuantity - previousQuantity : previousQuantity - currentQuantity;
                    var color = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';

                    var itemDataFormatted = {
                        item_id: product.ProductId.toString(),
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: index,
                        item_brand: product.Manufacturer,
                        item_list_id: listKey,
                        item_list_name: listKey,
                        item_variant: color,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: quantity
                    };

                    // Extend item data with category levels
                    var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                    // Multiply product price by quantity to calc the total value added
                    var value = parseFloat(quantity) * parseFloat(product.Prices.PriceWithoutVatN);

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': eventType,
                        'ecommerce': {
                            'currency': LhApp.Context.Currency.Code,
                            'value': value,
                            'items': [itemDataFormattedExtended] // Put the object in Array[0]
                        }
                    })
                }
            }

            //TRACK Cart Page - Push "view_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_view_cart_page', function (envelope) {
                previousCartModel = cartModel;
                cartModel = envelope.message.data.Cart;

                if (!cartModel) return;

                if (quantityChanged) {
                    trackQuantityChange(cartModel, previousCartModel);
                    return; // Dont track view_cart if item quantity changed
                }

                if (!TrackingModel.IsCartPage) return;

                if (dontTrackNextViewCart) {
                    dontTrackNextViewCart = false;
                    return; // Dont track if item removed from cart
                }

                var items = []; // Push Each Item from the model to the array

                cartModel.Items.forEach(function (product, index) {

                    var pdColor = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                    var pdList = '', pdIndex = 0;

                    if (product.IsFreeGift) {
                        pdList = 'FREE GIFT';
                        pdIndex = 1;
                    } else {
                        var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                        pdList = (mapItem) ? mapItem.list : '';
                        pdIndex = (mapItem) ? mapItem.index : 0;
                    }

                    var itemDataFormatted = {
                        item_id: product.ProductId.toString(),
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: pdIndex,
                        item_brand: product.Manufacturer,
                        item_list_id: pdList,
                        item_list_name: pdList,
                        item_variant: pdColor,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    };

                    // Extend item data with category levels
                    var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                    items.push(itemDataFormattedExtended);
                });

                var totalPriceWithoutVat = parseFloat(cartModel.Summary.TotalWithoutVat.replace(',', '.'));

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': totalPriceWithoutVat,
                        'items': items // ProductData (Model) to DataLayer
                    }
                })

            });

            //TRACK View Mini Cart Widget - Push "view_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, TrackingScriptName + '_view_mini_cart', function (envelope) {

                if (envelope.message.data.widgetName !== "CartWidget") return; // Check if this is CartWidget

                if (dontTrackNextViewCart) {
                    dontTrackNextViewCart = false;
                    return; // Dont track if item removed from cart
                }

                var items = []; // Push Each Item from the model to the array

                cartModel.Items.forEach(function (product, index) {

                    var pdColor = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                    var pdList = '', pdIndex = 0;

                    if (product.IsFreeGift) {
                        pdList = 'FREE GIFT';
                        pdIndex = 1;
                    } else {
                        var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                        pdList = (mapItem) ? mapItem.list : '';
                        pdIndex = (mapItem) ? mapItem.index : 0;
                    }

                    var itemDataFormatted = {
                        item_id: product.ProductId.toString(),
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: pdIndex,
                        item_brand: product.Manufacturer,
                        item_list_id: pdList,
                        item_list_name: pdList,
                        item_variant: pdColor,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    };

                    // Extend item data with category levels
                    var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                    items.push(itemDataFormattedExtended);
                });

                var totalPriceWithoutVat = parseFloat(cartModel.Summary.TotalWithoutVat.replace(',', '.'));

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': totalPriceWithoutVat,
                        'items': items // CartProductsData (Model) to DataLayer
                    }
                })

            });

            //TRACK View Selected Item (When color change) - Push "view_item" Event
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName + '_view_selected_item', function (envelope) {

                var selectedColorId = envelope.message.data.model.SelectedProductColorId;

                if (!TrackingModel.ProductData) return;

                if (currentColor == selectedColorId) return; // Do not execute if the same color is selected

                currentColor = selectedColorId; // Reset current color

                var product = TrackingModel.ProductData[0];
                var pdColor = '';

                // Find color of this product
                if (product.Colors && product.Colors.length > 0) {
                    product.ColorData = product.Colors.filter(function (i) { return i.VersionId == selectedColorId; })[0];
                    pdColor = product.ColorData.Name;
                }

                var lastListCookie = Cookies.get('LastListObj');
                lastListCookie = (lastListCookie) ? JSON.parse(lastListCookie) : null;
                var pdList = (lastListCookie && lastListCookie.listKey) ? lastListCookie.listKey : '';
                var pdIndex = (lastListCookie && lastListCookie.index) ? lastListCookie.index : 0;
   
                // Structure product data for analytics
                var itemDataFormatted = {
                    item_id: product.ProductId.toString(),
                    item_name: product.Name,
                    affiliation: "Online Store",
                    currency: LhApp.Context.Currency.Code,
                    index: pdIndex,
                    item_brand: product.Brand,
                    item_list_id: pdList,
                    item_list_name: pdList,
                    item_variant: pdColor,
                    price: product.PriceWithoutVatN,
                    quantity: product.Quantity
                };

                // Extend item data with category levels
                var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'view_item', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': product.PriceWithoutVatN, // Total price = Item price
                        'items': [itemDataFormattedExtended] // Put the object in Array[0]
                    }
                })
            });

            //TRACK product list - Push "view_item_list" Event (asynchronous)
            Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, TrackingScriptName, function (envelope) {                
                triggerViewItemList(); // Runs once

                if (!PLScrollRegistered) {
                    $(window).scroll($.debounce(300, triggerViewItemList)); // Runs when user scrolls
                    PLScrollRegistered = true;
                }
            });

            //HELPER this script keeps track of products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName + '_add_to_cart', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;
                var $envSenderList = $(envelope.sender).closest('.x-product-list');
                var isQuickBuy = ($(envelope.sender).hasClass('x-cart-searchbox'));
                var listKey = '';
                var listType = $envSenderList.data('trackinglist-type');
                var listTitle = $envSenderList.data('list-title');
                var index = 0;

                if (listType == 'amazon-recom-pd') {
                    listKey = 'Amazon Recommendation PD';
                    index = $('.x-product-box', $envSenderList).index(envelope.sender) + 1;
                }
                else if (listType == 'amazon-recom-cart') {
                    listKey = 'Amazon Recommendation Cart';
                    index = $('.x-product-box', $envSenderList).index(envelope.sender) + 1;
                }
                else if (isQuickBuy) {
                    listKey = 'Γρήγορη Αγορά';
                    index = homeQuickBuyItemIndex || 1;
                }
                else if (listTitle) {
                    listKey = listTitle;
                    index = $('.x-product-box', $envSenderList).index(envelope.sender) + 1;
                }

                else {
                    var lastListCookie = Cookies.get('LastListObj');
                    lastListCookie = (lastListCookie) ? JSON.parse(lastListCookie) : null;
                    listKey = (lastListCookie && lastListCookie.listKey) ? lastListCookie.listKey : '';
                    index = (lastListCookie && lastListCookie.index) ? lastListCookie.index : 0;
                }

                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty),
                    listKey,
                    index
                });
            });

            //HELPER this script keeps track of multiple products added to cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAdd, TrackingScriptName + '_add_multiple_to_cart', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;

                res.forEach(function (prod, index) {

                    _cartAddResponses.push({
                        ProductId: prod.id,
                        SkuId: prod.skuId,
                        Quantity: parseFloat(prod.qty),
                        listKey: 'Combo',
                        index
                    });

                });

            });

            //HELPER this script keeps track of products added to cart from wishlist page
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ProductAdded, TrackingScriptName + '_add_to_cart_from_wishlist', function (envelope) {

                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message.data) return;

                var res = envelope.message.data;
                _cartAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    listKey: 'Wishlist',
                    index: 1
                });
            });

            //HELPER this script keeps track of "move all to cart" from the wishlist page
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveAllToCart, TrackingScriptName + '_move_all_to_cart_from_wishlist', function (envelope) {

                if ((LhApp.Context.Item.Template != "wishlist") || !envelope.message || (wishModel.Items.length <= 0)) return;

                wishModel.Items.forEach(function (Item, index) {
                    _cartAddResponses.push({
                        ProductId: Item.ProductId,
                        SkuId: Item.VariantId,
                        listKey: 'Wishlist',
                        index
                    });
                });

            });

            //TRACK add to cart (recorded by the ABOVE script) - Push "add_to_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName + '_add_to_cart_success', function (envelope) {

                cartModel = envelope.message.data.Cart;

                if (!cartModel || !_cartAddResponses) return;

                var pAddResponse = _cartAddResponses.shift();

                (function AddToCartTrack(p) {
                    if (!p)
                        return;

                    var product = cartModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (product) {
                        var pdColor = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';

                        var itemDataFormatted = {
                            item_id: product.ProductId.toString(),
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: p.index,
                            item_brand: product.Manufacturer,
                            item_list_id: p.listKey,
                            item_list_name: p.listKey,
                            item_variant: pdColor,
                            price: product.Prices.PriceWithoutVatN,
                            quantity: product.Quantity
                        };

                        // Extend item data with category levels
                        var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                        // Multiply product price by quantity to calc the total value added
                        var value = parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN);

                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_to_cart', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': value,
                                'items': [itemDataFormattedExtended] // Put the object in Array[0]
                            }
                        })

                        listToProductMap.items.push({ variantId: product.VariantId, list: p.listKey, index: p.index }); // Save list of product
                        localStorage.setItem('listToProductMap', JSON.stringify(listToProductMap));
                    }

                    AddToCartTrack(_cartAddResponses.shift());

                })(pAddResponse);
            });

            //HELPER this script keeps track of products added to wishlist 
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Add, TrackingScriptName + '_add_to_wishlist', function (envelope) {

                if (!envelope.message.data) return;

                var res = envelope.message.data;
                _wishAddResponses.push({
                    ProductId: res.id,
                    SkuId: res.skuId,
                    Quantity: parseFloat(res.qty)
                });
            });

            //TRACK add to wishlist (recorded by the ABOVE script) - Push "add_to_wishlist" Event
            Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, TrackingScriptName + '_add_to_wishlist_success', function (envelope) {

                wishModel = envelope.message.data;

                if (!wishModel || !_wishAddResponses) return;

                var pAddResponse = _wishAddResponses.shift();

                (function AddToWishTrack(p) {
                    if (!p)
                        return;

                    var product = wishModel.Items.filter(function (i) {
                        return i.ProductId == p.ProductId && i.VariantId == p.SkuId;
                    })[0];

                    if (product) {

                        var pdFirstDimension = (product.Dimensions[0] && product.Dimensions[0].Name) ? product.Dimensions[0].Name : '';
                        var pdPriceWithoutVatN = parseFloat(product.Prices.PriceWithoutVat.replace(',', '.'));
                        
                        var itemDataFormatted = {
                            item_id: product.ProductId.toString(),
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: 0,
                            item_brand: product.Manufacturer,
                            item_variant: pdFirstDimension,
                            price: pdPriceWithoutVatN,
                            quantity: product.Quantity
                        };

                        // Extend item data with category levels
                        var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                        dataLayer.push({
                            'event': 'add_to_wishlist', // Event Name to identify in Tag Manager
                            'ecommerce': {
                                'currency': LhApp.Context.Currency.Code,
                                'value': product.PriceWithoutVat,
                                'items': [itemDataFormattedExtended] // Put the object in Array[0]
                            }
                        })

                    }

                    AddToWishTrack(_wishAddResponses.shift());

                })(pAddResponse);
            });

            //TRACK remove item from cart - Push "remove_from_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, TrackingScriptName + '_remove_from_cart', function (envelope) {

                if (!cartModel || !envelope.message.data) return;

                var product = cartModel.Items.filter(function (i) {
                    return i.Id == envelope.message.data.id;
                })[0];

                if (product) {
                    var pdColor = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                    var pdList = '', pdIndex = 0;

                    if (product.IsFreeGift) {
                        pdList = 'FREE GIFT';
                        pdIndex = 1;
                    } else {
                        var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                        pdList = (mapItem) ? mapItem.list : '';
                        pdIndex = (mapItem) ? mapItem.index : 0;
                    }

                    var itemDataFormatted = {
                        item_id: product.ProductId.toString(),
                        item_name: product.Title,
                        affiliation: "Online Store",
                        currency: LhApp.Context.Currency.Code,
                        index: pdIndex,
                        item_brand: product.Manufacturer,
                        item_list_id: pdList,
                        item_list_name: pdList,
                        item_variant: pdColor,
                        price: product.Prices.PriceWithoutVatN,
                        quantity: product.Quantity
                    };

                    // Extend item data with category levels
                    var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                    // Multiply product price by quantity to calc the total value added
                    var value = parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN);

                    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    dataLayer.push({
                        'event': 'remove_from_cart', // Event Name to identify in Tag Manager
                        'ecommerce': {
                            'currency': LhApp.Context.Currency.Code,
                            'value': value,
                            'items': [itemDataFormattedExtended] // Put the object in Array[0]
                        }
                    })

                    listToProductMap.items = listToProductMap.items.filter(function (i) { return i.variantId != product.VariantId; });
                    localStorage.setItem('listToProductMap', JSON.stringify(listToProductMap));

                    dontTrackNextViewCart = true;
                }
            });

            //HELPER to start multiple items removal from cart
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemove, TrackingScriptName + '_remove_multiple', function (envelope) {
                if (!envelope.message.data) return;
                idsToRemove = envelope.message.data; // Save ids of items that are getting removed from the cart
            });

            //TRACK remove multiple items from cart - Push "remove_from_cart" Event
            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemoveSuccess, TrackingScriptName + '_remove_multiple_from_cart', function (envelope) {

                if (!cartModel || !envelope.message.data.success || idsToRemove <= 0) return;

                var items = []; // Init items array to send to the datalayer
                var value = 0; // Init total value of items to send to the datalayer

                idsToRemove.forEach(function (id, index) {

                    var product = cartModel.Items.filter(function (i) {
                        return i.Id == id;
                    })[0];

                    if (product) {
                        var pdColor = (product.Dimensions[0] && product.Dimensions[0].Color) ? product.Dimensions[0].Color : '';
                        var pdList = '', pdIndex = 0;

                        if (product.IsFreeGift) {
                            pdList = 'FREE GIFT';
                            pdIndex = 1;
                        } else {
                            var mapItem = listToProductMap.items.filter(function (i) { return i.variantId === product.VariantId })[0];
                            pdList = (mapItem) ? mapItem.list : '';
                            pdIndex = (mapItem) ? mapItem.index : 0;
                        }

                        var itemDataFormatted = {
                            item_id: product.ProductId.toString(),
                            item_name: product.Title,
                            affiliation: "Online Store",
                            currency: LhApp.Context.Currency.Code,
                            index: pdIndex,
                            item_brand: product.Manufacturer,
                            item_list_id: pdList,
                            item_list_name: pdList,
                            item_variant: pdColor,
                            price: product.Prices.PriceWithoutVatN,
                            quantity: product.Quantity
                        };

                        // Extend item data with category levels
                        var itemDataFormattedExtended = addCategories(itemDataFormatted, product);

                        items.push(itemDataFormattedExtended); // Push this item to array of items that are removed.

                        value += parseFloat(product.Quantity) * parseFloat(product.Prices.PriceWithoutVatN); // Add value to total

                        listToProductMap.items = listToProductMap.items.filter(function (i) { return i.variantId != product.VariantId; });
                    }
                });

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    'event': 'remove_from_cart', // Event Name to identify in Tag Manager
                    'ecommerce': {
                        'currency': LhApp.Context.Currency.Code,
                        'value': value,
                        'items': items
                    }
                })

                localStorage.setItem('listToProductMap', JSON.stringify(listToProductMap));
            });

            //TRACK register - Push "sign_up" Event
            Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterSuccess, TrackingScriptName + '_user_register', function (envelope) {

                if (!envelope.message.data.success) return;

                dataLayer.push({ 'method': null });
                dataLayer.push({
                    'event': 'sign_up', // Event Name to identify in Tag Manager
                    'method': "registration_form" // Sign up method
                });

            });

            //TRACK register - Push "sign_up" Event on b2b registration page
            Vendd.MessageBus.subscribe(Vendd.User.Messages.B2BRegisterSuccess, TrackingScriptName + '_b2b_user_register', function (envelope) {

                if (!envelope.message.data.success) return;

                dataLayer.push({ 'method': null });
                dataLayer.push({
                    'event': 'sign_up', // Event Name to identify in Tag Manager
                    'method': "b2b_registration_form" // Sign up method
                });

            });

            //HELPER login
            Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, TrackingScriptName + '_user_login', function (envelope) {
                if (!envelope.message.data.success || loginTracked) return;

                var method = '';
                if (LhApp.Context.Item.Template == 'register') {
                    method = "registration_form";
                } else if (LhApp.Context.Item.Template == 'b2bregistrationpage') {
                    method = "b2b_registration_form";
                } else {
                    method = "login_form";
                }

                var loginEvent = {
                    'event': 'login', // Event Name to identify in Tag Manager
                    'method': method // Login method
                };

                localStorage.setItem('login_event', JSON.stringify(loginEvent));
                loginTracked = true; // Prevent double fire of login event

            });

            //Update of product list version & tracked items
            Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, TrackingScriptName + '_pl_update', function (envelope) {
                if (!envelope.message || !envelope.message.data || !envelope.isAsync) return;
                var response = envelope.message.data;

                if (response.success && response.position == "Reload") {
                    var $list = $(response.list);
                    var listCurrentVersion = parseInt($list.attr('data-list-version')) || 1;
                    $list.attr('data-list-version', listCurrentVersion + 1);
                    $list.attr('data-list-tracked-items', 0);
                }
            });

            //Track updated product list 
            Vendd.MessageBus.subscribe(Vendd.Tracking.Messages.ProductsUpdated, TrackingScriptName + '_pl_productsUpdated', function (envelope) {
                if (typeof triggerViewItemList === 'function') {
                    triggerViewItemList();
                }
            });
        }

        //HELPER to add category levels in item data before push
        function addCategories(itemDataFormatted, product) {
            if (product.TrackingPath) {
                product.TrackingPath.forEach(function (category, index) {
                    if (index < 1) {
                        itemDataFormatted.item_category = category;
                    } else if (index >= 1 && index <= 4) {
                        itemDataFormatted['item_category' + (index + 1)] = category;
                    } else {
                        return false;
                    }
                });
            } else {
                if (product.Category) {
                    itemDataFormatted.item_category = product.Category;
                } else if (product.CategoryName) {
                    itemDataFormatted.item_category = product.CategoryName;
                } else {
                    itemDataFormatted.item_category = null;
                }
            }

            return itemDataFormatted;
        };

        //HELPER to combine multiple coupon codes into single string
        function combineCoupons(coupons) {
            var couponCodes = [];
            coupons.forEach(function (coupon) {
                if (!coupon.Code) return;
                couponCodes.push(coupon.Code);
            });
            return couponCodes.join(', ');
        }
    });
})();
